// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bjQR","left":"styles_left__36wCf"};